module.exports = __webpack_public_path__ + "static/media/FEED BACK ARM LINK.895fef95.jpg";